const header = document.querySelector('.page-header');

// Added Class to header on scroll
document.addEventListener('scroll', () => {
    if (window.pageYOffset > 50) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

// Copy current url to clipboard
const buttonClipboard = document.querySelector('.clipboard-js');

function copyURLToClipboard() {
    const currentURL = window.location.href;

    navigator.clipboard.writeText(currentURL).then(() => {
        console.log('URL copied to clipboard successfully:', currentURL);
    }, err => {
        console.error('Unable to copy URL to clipboard: ', err);
    });
}

if(buttonClipboard) {
    buttonClipboard.addEventListener('click', () => {
        copyURLToClipboard();
    });
}

// burger menu toggle
if (document.querySelector('.burger-wrapper')) {
    document.querySelector('.burger-wrapper').addEventListener('click', function H() {
        let __this = this;

        __this.classList.toggle('open');
        document.querySelector('.page-header__inner').classList.toggle('open');
        header.classList.toggle('open');
        document.querySelector('.page-body').classList.toggle('show');
    });
}

// Expand Menu Mobile
const menuExpandList = document.querySelectorAll('.mega-menu-grid');

if (window.innerWidth <= 1024) {
    menuExpandList.forEach(menuExpand => {
        menuExpand.addEventListener('click', function () {
            const subMenu = this.querySelector('.mega-sub-menu');
            const menuRow = this.querySelector('.mega-sub-menu .mega-menu-row');

            if (!subMenu || !menuRow) return;

            const menuHeight = menuRow.getBoundingClientRect().height;

            if (subMenu.classList.contains('show')) {
                subMenu.style.maxHeight = `0px`;
                subMenu.classList.remove('show');
                this.querySelector('.mega-menu-link').classList.remove('open');
            } else {
                subMenu.classList.add('show');
                subMenu.style.maxHeight = `${menuHeight}px`;
                this.querySelector('.mega-menu-link').classList.add('open');
            }
        });
    });
}
